import { Link } from "react-router-dom";

import { getLink, trans } from "~/providers/lang";
import { ROUTES } from '~/const';
import { useSeo } from "~/hooks/useSeo";

import "./style.less";

export default function GalleriesPage() {
	useSeo({
		title: trans("skelet.title.gallery"),
		canonical: "galerie",
	});

	return <div className="body-background">
		<div className="gallery-page page-content top-shadow">
			<h1 className="other-page-title">
				{trans('gallery.title')}
			</h1>
			<div className="row">
				<div className="col-md-4">
					<Link to={getLink(ROUTES.galleryWedding)}>
						<img src="/img/gallery-1.png" alt={trans('gallery.preview')} className="with-border click" />
					</Link>
					<h2>
						{trans('gallery.wedding.title')}
					</h2>
					<p className="desc">
						{trans('gallery.wedding.desc')}
					</p>
				</div>
				<div className="col-md-4">
					<Link to={getLink(ROUTES.galleryFormal)}>
						<img src="/img/gallery-2.png?2" alt={trans('gallery.preview')} className="with-border click" />
					</Link>
					<h2>
						{trans('gallery.formal.title')}
					</h2>
					<p className="desc">
						{trans('gallery.formal.desc')}
					</p>
				</div>
				<div className="col-md-4">
					<Link to={getLink(ROUTES.galleryAddons)}>
						<img src="/img/gallery-3.png" alt={trans('gallery.preview')} className="with-border click" />
					</Link>
					<h2>
						{trans('gallery.addons.title')}
					</h2>
					<p className="desc">
						{trans('gallery.addons.desc')}
					</p>
				</div>
			</div>
			<div className="space-betwwen"></div>
			<div className="row">
				<div className="col-md-4">
					<Link to={getLink(ROUTES.gallerySchoolWedding)}>
						<img src="/img/gallery-4.png?1" alt={trans('gallery.preview')} className="with-border click" />
					</Link>
					<h2>
						{trans('gallery.schoolWedding.title')}
					</h2>
					<p className="desc">
						{trans('gallery.schoolWedding.desc')}
					</p>
				</div>
				<div className="col-md-4">
					<Link to={getLink(ROUTES.galleryAction)}>
						<img src="/img/gallery-5.png" alt={trans('gallery.preview')} className="with-border click" />
					</Link>
					<h2>
						{trans('gallery.action.title')}
					</h2>
					<p className="desc">
						{trans('gallery.action.desc')}
					</p>
				</div>
				<div className="col-md-4">
					<Link to={getLink(ROUTES.galleryShop)}>
						<img src="/img/gallery-6.png?5" alt={trans('gallery.preview')} className="with-border click" />
					</Link>
					<h2>
						{trans('gallery.shop.title')}
					</h2>
					<p className="desc">
						{trans('gallery.shop.desc')}
					</p>
				</div>
			</div>
		</div>
	</div>;
}
